import { Typography } from "@mui/material";

interface FormLabelProps {
  label: string;
  required?:boolean;
}

const FormLabel: React.FC<FormLabelProps> = ({ label,required = false }) => {
  return (
    <>
      <Typography
        mb={{
          xs: 1,
          md: 2,
        }}
        sx={{
          fontWeight: 500,
          fontSize: {
            xs: "16px",
            md: "20px",
          },
          mt: {
            xs: "10px",
            md: "0px",
          },

          color: "#026E91",
        }}
      >
        {label}
        {
          required && (
            <span style={{ color:"red" , fontWeight:"bold"}}> *</span>
          )
        }
      </Typography>
    </>
  );
};

export default FormLabel;
